import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  background: ${props => props.darkMode === true ? '#1a1d24' : 'white'};
  
  border: 1px solid #E5E7EB;
  border-radius: 14px;

  padding: 20px;

  box-shadow: 0 1px 3px rgba(15, 23, 42, .05);
`;

// export const Container = styled.div`
//   background: #fff;

//   border: 1px solid #eef2f7;

//   border-radius: 16px;

//   padding: 20px;

//   margin-bottom: 24px;

//   box-shadow:
//     0 1px 2px rgba(16,24,40,0.04),
//     0 4px 12px rgba(16,24,40,0.04);
// `;